export const updateLayerVisibilitySingle = (map, item, state) => {
  const mapLayer = map.getLayer(item);
  const mapLayerPoligons = map.getLayer(`${item}-poligons`);

  if (typeof mapLayer !== 'undefined') {
    map.setLayoutProperty(mapLayer.id, 'visibility', state);
  }

  if (typeof mapLayerPoligons !== 'undefined') {
    map.setLayoutProperty(mapLayerPoligons.id, 'visibility', state);
  }
};

export default (map, updatedList, oldList) => {
  const diffListAdd = updatedList.filter((item) => !oldList.includes(item));

  if (diffListAdd.length > 0) {
    diffListAdd.forEach((item) => {
      updateLayerVisibilitySingle(map, item, 'visible');
    });
  } else {
    const diffListRemove = oldList.filter((item) => !updatedList.includes(item));

    diffListRemove.forEach((item) => {
      updateLayerVisibilitySingle(map, item, 'none');
    });
  }
};
